// Api
import API from '@/api'
// Services
import { http } from '@/boot/axios'

// Admin de Analytics del Super Admin. Los payloads viajan en snake_case: el store los arma.
const BASE_URL = `${API.GRAPHQL_URL}admin/analytics/`

// Los ids de la URL del navegador llegan al path del request: se codifican para que no puedan llevar `../`.
const segment = (id) => encodeURIComponent(id)

export default {
  fetchSourceStatus () {
    return http.get(`${BASE_URL}source-status`)
  },

  // Catálogo completo, sin paginar: activos e inactivos, en el orden global.
  fetchDashboards () {
    return http.get(`${BASE_URL}dashboards`)
  },

  // Incluye `organizations`: dónde está habilitado el tablero. `config` admite `signal` para abortar.
  fetchDashboard (dashboardId, config = {}) {
    return http.get(`${BASE_URL}dashboards/${segment(dashboardId)}`, config)
  },

  createDashboard (payload) {
    return http.post(`${BASE_URL}dashboards`, payload)
  },

  updateDashboard (dashboardId, payload) {
    return http.put(`${BASE_URL}dashboards/${segment(dashboardId)}`, payload)
  },

  setDashboardStatus (dashboardId, isActive) {
    return http.patch(`${BASE_URL}dashboards/${segment(dashboardId)}/status`, { is_active: isActive })
  },

  // Debe incluir todos los tableros del catálogo; responde el catálogo en el orden nuevo.
  reorderDashboards (dashboardIds) {
    return http.put(`${BASE_URL}dashboards/order`, { dashboard_ids: dashboardIds })
  },

  // Paginado en servidor: limit, page, search, status, sort_by, sort_dir. `config` admite `signal` para abortar.
  fetchOrganizations (params, config = {}) {
    return http.get(`${BASE_URL}organizations`, { params, ...config })
  },

  fetchOrganizationsSummary () {
    return http.get(`${BASE_URL}organizations/summary`)
  },

  // Solo organizaciones sin Analytics, máximo 50.
  searchAvailableOrganizations (search) {
    return http.get(`${BASE_URL}organizations/available`, { params: { search } })
  },

  enableOrganization (payload) {
    return http.post(`${BASE_URL}organizations`, payload)
  },

  // Incluye `dashboards` (habilitados, en su orden efectivo) y `order_mode`.
  fetchOrganization (organizationId, config = {}) {
    return http.get(`${BASE_URL}organizations/${segment(organizationId)}`, config)
  },

  // Conjunto final de tableros habilitados y modo de orden.
  saveOrganizationDashboards (organizationId, payload) {
    return http.put(`${BASE_URL}organizations/${segment(organizationId)}/dashboards`, payload)
  },

  setOrganizationStatus (organizationId, isActive) {
    return http.patch(`${BASE_URL}organizations/${segment(organizationId)}/status`, { is_active: isActive })
  },

  updateOrganizationRlsIdentity (organizationId, rlsIdentity) {
    return http.patch(`${BASE_URL}organizations/${segment(organizationId)}/rls-identity`, { rls_identity: rlsIdentity })
  },

  // Matriz paginada en servidor: limit, page, search, access, dashboard_id, franchise_id, sort_by, sort_dir.
  // `config` admite `signal` para abortar.
  fetchOrganizationUsers (organizationId, params, config = {}) {
    return http.get(`${BASE_URL}organizations/${segment(organizationId)}/users`, { params, ...config })
  },

  // Unidades de negocio de la organización para el filtro, máximo 50: search.
  fetchOrganizationFranchises (organizationId, search) {
    return http.get(`${BASE_URL}organizations/${segment(organizationId)}/franchises`, { params: { search } })
  },

  // Da o quita acceso a usuarios × tableros: { user_ids, dashboard_ids, has_access }.
  updateUserAccess (organizationId, payload) {
    return http.put(`${BASE_URL}organizations/${segment(organizationId)}/users/access`, payload)
  }
}
